module.exports = __webpack_public_path__ + "static/media/camera.9fb23cc5.svg";